import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const NameMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="#########################################################"
        definitions={{
          '#': /[\u00c0-\u01ffa-zA-Z'-]/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const CpfMask = forwardRef<HTMLElement, CustomProps>(function CodeCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000.000.000-00"
      definitions={{
        '#': /^[0-9]$/,
      }}
      onAccept={(value: any) =>
        onChange({ target: { name: props.name, value } })
      }
      overwrite
    />
  );
});

export const PhoneMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(00) 00000-0000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const PhoneHomeMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(00) 0000-0000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const voterRegistrationMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="0000 0000 0000 0000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const birthdayMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="00/00/0000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const cepMask = forwardRef<HTMLElement, CustomProps>(function CodeCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="00000-000"
      definitions={{
        '#': /^[0-9]$/,
      }}
      onAccept={(value: any) =>
        onChange({ target: { name: props.name, value } })
      }
      overwrite
    />
  );
});

export const highSchoolCompletionMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="00/0000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const enemSubscriptionMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000000000000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);

export const testScoreMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props: any, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000#@"
        onAccept={(value: any) => {
          onChange({ target: { name: props.name, value } });
        }}
        definitions={{
          '#': /([.]|[0-9])/,
          '@': props.value !== '1000' ? /^[0-9]$/ : '',
        }}
        overwrite
      />
    );
  },
);

export const addressNumberMask = forwardRef<HTMLElement, CustomProps>(
  function CodeCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000000000000"
        definitions={{
          '#': /^[0-9]$/,
        }}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  },
);
